<app-hero></app-hero>
<app-weather-conditions></app-weather-conditions>
<!-- <app-mapa></app-mapa> -->
<app-news></app-news>
<!-- <app-cotacao></app-cotacao> -->
<app-about></app-about>
